import React from 'react'
import Header from '../../component/Header'
import ContactUs from '../ContactUs'
import Footer from '../../component/Footer'

export default function LayoutContactUs() {
    return (
        <div>
            <Header />
            <ContactUs />
            <Footer />
        </div>
    )
}
